import API from './fetchAPI';

const normalizeCaseId = value => {
  if (value == null) return null;
  return String(value).trim();
};

export const fetchUmapCaseData = async (lab, selectedCaseID, startDate = null, endDate = null) => {
  try {
    if (!lab)
       return null;

    const response = await API.get(`/api/labs/get/cases/${lab}`, {
      doNotThrowFor: [404]
    });

    const filteredCases = response.cases.filter((caseItem) => {
      if (!caseItem.hpoTerms || caseItem.hpoTerms.length === 0) return false;

      // befunddatum is only needed to test a date range -- when neither bound
      // is given (VariantView.jsx / Grid.jsx: single-case UMAP lookups, always
      // called with startDate=endDate=null) skip it entirely. Previously this
      // ran unconditionally, so any case with a missing/unparseable befunddatum
      // was silently dropped even when no date filtering was requested at all
      // -- in production this zeroed out every case for 14 labs (~6,400 cases
      // with perfectly good hpoTerms) purely because their befunddatum didn't
      // parse, breaking the UMAP button for those labs entirely.
      if (startDate || endDate) {
        const caseTimestamp = Date.parse(caseItem.befunddatum);
        if (isNaN(caseTimestamp)) return false;

        const caseDate = new Date(caseTimestamp);
        if (startDate && endDate) return caseDate >= startDate && caseDate <= endDate;
        if (startDate) return caseDate >= startDate;
        if (endDate) return caseDate <= endDate;
      }

      return true;
    });

    const transformed = filteredCases.map((caseItem) => ({
      case_ID_paper: normalizeCaseId(caseItem.internalCaseId),
      HPO_Term_IDs: caseItem.hpoTerms.join("; "),
      novel_disease_gene: false,
      disease_category: caseItem.diseaseCategory || 'other',
      variantId: caseItem.variants?.[0]?.variant?.reference || null
    }));

    if (transformed.length === 0) return null;
    console.log("Transformed UMAP case data:", transformed);
    return {
      cases: transformed,
      lab: "allLabs",
      redo: "no",
      // selected_case_id is the hidden DB identifier used to match/highlight the
      // point in the UMAP.
      selected_case_id: normalizeCaseId(selectedCaseID),
      selected: normalizeCaseId(selectedCaseID),
      // sequencingLab of the selected case, so the backend can decide whether
      // case IDs are visible in the UMAP using the same same-lab-or-superuser
      // rule the cases table uses to redact internalCaseId. Stripped by the
      // backend before it's forwarded to the visualiser.
      caseSequencingLab: lab
    };
  } catch (error) {
    console.error("Failed to fetch UMAP case data:", error);
    return null;
  }
}
